// extracted by mini-css-extract-plugin
export default {"pdfGrid":"Pdf_pdfGrid__Ekxpe","pdfDownload":"Pdf_pdfDownload__KzUF9","pdfButton":"Pdf_pdfButton__aRev9","pdfCanvas":"Pdf_pdfCanvas__aC4-r"};